import { render } from "./FeatureFlagAdmin.vue?vue&type=template&id=abee06c8&scoped=true"
import script from "./FeatureFlagAdmin.vue?vue&type=script&lang=js"
export * from "./FeatureFlagAdmin.vue?vue&type=script&lang=js"

import "./FeatureFlagAdmin.vue?vue&type=style&index=0&id=abee06c8&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abee06c8"]])

export default __exports__